module.exports = __webpack_public_path__ + "img/stock3.4a1fa594.png";